<template>
  <div class="list-filters__quick">
    <b-form @submit.prevent="emitFilters">
      <b-row>
        <b-col>
           <b-form-checkbox v-model="autoApply" :value="true" :unchecked-value="false">
            <translate>Auto Apply Filters</translate>
          </b-form-checkbox>
        </b-col>
        <b-col class="text-center filter-actions mb-3">
          <b-badge role="link" @click="resetQuickFilters" ref="resetFilters" v-translate>Reset Filters</b-badge>
          <b-badge role="link" @click="saveCurrentQuickFilters" v-if="!noQuerystring" v-translate>Save this Filters' Set</b-badge>
        </b-col>
        <b-col>

        </b-col>
      </b-row>
      <b-row>
        <quick-filters-column
          :quick-filters="quickFilters"
          :column="column"
          v-for="(column, indexColumn) in filters.columns"
          :key="indexColumn"
          :class="column.class"
        />
      </b-row>
      <b-row v-if="!autoApply">
        <b-col>
          <b-button variant="primary" type="submit" v-translate>
            Apply Filters
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import QuickFiltersColumn from './QuickFiltersColumn'

export default {
  name: 'QuickFilters',
  components: {
    QuickFiltersColumn
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true
    },
    quickFiltersDefinition: {
      type: Object,
      default: () => {}
    },
    noQuerystring: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quickFilters: {},
      filters: {},
      filterCallbacks: {},
      autoApply: this.getLocalStorage(this.preferenceStorageKey('autoApply')) && this.getLocalStorage(this.preferenceStorageKey('autoApply'))[this.type] ? this.getLocalStorage(this.preferenceStorageKey('autoApply'))[this.type] : false
    }
  },
  watch: {
    quickFilters: {
      handler () {
        if (this.autoApply) {
          this.emitFilters()
        }
      },
      deep: true
    },
    autoApply(val) {
      const currentAutoApply = this.getLocalStorage(this.preferenceStorageKey('autoApply')) || {}
      if (val) {
        currentAutoApply[this.type] = true
      } else {
        currentAutoApply[this.type] = false
      }
      this.setLocalStorage(this.preferenceStorageKey('autoApply'), currentAutoApply)
    },
    '$language.current': {
      handler() {
        this.$nextTick(() => {
          this.filters = this.quickFiltersDefinition.filters
        })
      },
      deep: true
    }
  },
  created() {
    window.addEventListener('popstate', () => {
      if (this.$route.query.af) {
        this.tabIndex = 1
        this.$nextTick(() => {
          this.init()
        })
      } else if (this.$route.query.qf) {
        this.tabIndex = 0
        this.$nextTick(() => {
          this.init()
        })
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
    // FIXME: quick & dirty hack for checkboxes options without values on refresh
    setTimeout(() => {
      this.init()
    }, 1000)
  },
  methods: {
    init() {
      this.filters = { ...this.quickFiltersDefinition.filters }
      this.setFilterCallbacks(this.quickFiltersDefinition.filters)
      if (this.$route.query.qf && !this.noQuerystring) {
        this.quickFilters = JSON.parse(this.$route.query.qf)
        this.emitFilters()
      } else {
        this.setFilters()
      }
    },
    resetQuickFilters() {
      if (!this.noQuerystring) {
        this.$router.push({ query: null })
      }
      this.$root.$emit('bv::refresh::table', this.type)
      this.$emit('reset')
    },
    setFilters(filters = this.filters) {
      filters.columns.forEach(column => {
        column.filters.forEach(filter => {
          if (filter.name) {
            this.$set(this.quickFilters, filter.name, filter.value)
          } else {
            this.setFilters(filter)
          }
        })
      })
    },
    setFilterCallbacks(filters = this.filters) {
      filters.columns.forEach(column => {
        column.filters.forEach(filter => {
          if (filter.name) {
            this.$set(this.filterCallbacks, filter.name, filter.callback)
          } else {
            this.setFilterCallbacks(filter)
          }
        })
      })
    },
    saveCurrentQuickFilters() {
      this.$emit('save-filter')
    },
    emitFilters() {
      let filtersToEmit = []
      const plainFiltersToEmit = []
      Object.entries(this.quickFilters).forEach(item => {
        if (typeof this.filterCallbacks[item[0]] === 'function') {
          const result = this.filterCallbacks[item[0]](item[1], this.quickFilters) || null
          if (Array.isArray(result)) {
            if (result.length === 1) {
              filtersToEmit.push(result[0])
            } else if (result.length > 1) {
              filtersToEmit = filtersToEmit.concat(result)
            }
          } else {
            plainFiltersToEmit.push(result)
          }
        }
      })

      this.$emit('filtering', { filtersToEmit, plainFiltersToEmit })

      if (!this.noQuerystring) {
        this.$router.push({ query: filtersToEmit.length > 0 ? { qf: JSON.stringify(this.quickFilters) } : null })
      }
    }
  }
}
</script>
